import { Injectable } from '@angular/core';
import moment from 'moment';
import { DateRange } from 'app/models/date-range';

@Injectable({ providedIn: 'root' })
export class DateRangeService {
    
    private ranges = null;
    constructor() {
        this.ranges = {
            'Today': [this.today.startDate, this.today.endDate],
            'Yesterday': [this.yesterday.startDate, this.yesterday.endDate],
            'Last 7 Days': [this.lastSevenDays.startDate, this.lastSevenDays.endDate],
            'Last 30 Days': [this.lastThirtyDays.startDate, this.lastThirtyDays.endDate],
            'This Month': [this.thisMonth.startDate, this.thisMonth.endDate],
            'Last Month': [this.lastMonth.startDate, this.lastMonth.endDate],
            'Last 3 Months': [this.lastThreeMonths.startDate, this.lastThreeMonths.endDate],
            'Last 6 Months': [this.lastSixMonths.startDate, this.lastSixMonths.endDate],
            'Last 9 Months': [this.lastNineMonths.startDate, this.lastNineMonths.endDate],
            'Last 12 Months': [this.lastTwelveMonths.startDate, this.lastTwelveMonths.endDate],
            'All Time': [this.allTime.startDate, this.allTime.endDate],
          };
    }
    
    get nullDateRange(): DateRange {
        return {startDate: null, endDate: null};
    }

    get today() : DateRange {
        return {startDate: moment(), 
                endDate: moment()};
    }

    get yesterday() : DateRange {
        return {startDate:moment().subtract(1, 'days'),
                endDate: moment().subtract(1, 'days')};
    }

    get lastSevenDays() : DateRange {
        return {startDate:moment().subtract(6, 'days'), 
                endDate: moment()};
    }

    get lastThirtyDays() : DateRange {
        return {startDate:moment().subtract(29, 'days'),
                endDate: moment()};
    }

    get thisMonth() : DateRange {
        return {startDate:moment().startOf('month'),
                endDate: moment().endOf('month')};
    }

    get lastMonth() : DateRange {
        return {startDate:moment().subtract(1, 'month').startOf('month'),
                endDate: moment().subtract(1, 'month').endOf('month')};
    }

    get lastThreeMonths() : DateRange {
        return {startDate: moment().subtract(3, 'month').startOf('month'),
                endDate: moment()};
    }

    get lastSixMonths() : DateRange {
        return {startDate: moment().subtract(6, 'month').startOf('month'),
                endDate: moment()};
    }

    get lastNineMonths() : DateRange {
        return {startDate: moment().subtract(9, 'month').startOf('month'),
                endDate: moment()};
    }

    get lastTwelveMonths() : DateRange {
        return {startDate: moment().subtract(12, 'month').startOf('month'),
                endDate: moment()};
    }

    get allTime() : DateRange {
        return {startDate: moment('0000-01-01'),
                endDate: moment('9999-12-31')};
    }

    get presetRanges() {
        return this.ranges;
    }
}